/*
  import { sidebarMenuItems } from '@/utilities/sidebarMenuItems/Homeowner'

  sidebarMenuItems ({
    hoaId
  })
*/

/*
  Feature List found at:
    [get] /Subscriptions/Feature/List { hoaID }
    
  Maybe partial list can be found at:
    src/utilities/Subscriptions/Features.txt
*/

/*
  toggle to turn the filter off
*/

import auth from '@/services/_auth'

import WorkOrderIcon from '@/components/icons/WorkOrder'
import ServicesIcon from '@/components/icons/Services'
import ViolationsIcon from '@/components/icons/Violations'
import Amenity2Icon from '@/components/icons/Amenity2'
import SurveyIcon from '@/components/icons/Survey'
import OpenPage from '@/components/icons/OpenPage'
import Billing from '@/components/icons/Billing'
import EvotingIcon from '@/components/icons/Evoting'
import AccountIcon from '@/components/icons/Account'
import PropertyIcon from '@/components/icons/Property'
import CustomerSupportIcon from '@/components/icons/CustomerSupport'
import HelpCenterIcon from '@/components/icons/HelpCenter'
import HouseIcon from '@/components/icons/House'

const apps = {
  tenants: {
    to: '/homeownerLease',
    iconC: HouseIcon,
    label: 'Tenants'
  },
  amenities: {
    to: '/amenities',
    iconC: WorkOrderIcon,
    label: 'Amenities'
  },
  workOrderRequests: {
    to: '/workOrderRequests',
    iconC: Amenity2Icon,
    label: 'Work Order Requests'
  },
  architecturalRequests: {
    to: '/architecturalRequests',
    iconC: ServicesIcon,
    label: 'Architectural Requests'
  },
  violations: {
    to: '/violations',
    iconC: ViolationsIcon,
    label: 'Violations'
  },
  directoryContacts: {
    to: '/directoryContacts',
    iconC: OpenPage,
    label: 'Homeowner Directory'
  },
  helpCenter: {
    to: '/helpCenter',
    iconC: HelpCenterIcon,
    label: 'Help Center'
  },
  communityCenter: {
    to: '/communityCenter',
    iconC: SurveyIcon,
    label: 'Community Info'
  },
  accountActivity: {
    to: '/billingtabs/accountActivity#tab',
    iconC: Billing,
    label: 'Billing'
  },
  evoting: {
    to: '/evoting',
    iconC: EvotingIcon,
    label: 'eVoting'
  },
  profile: {
    to: '/userSettings/profile#tab',
    iconC: AccountIcon,
    label: 'User Settings'
  },
  contacts: {
    to: '/property/contacts#tab',
    iconC: PropertyIcon,
    label: 'Property Settings'
  },
  customerSupport: {
    to: '/customerSupport',
    iconC: CustomerSupportIcon,
    label: 'Customer Support'
  }
}

export function sidebarMenuItems({ hoaId, enhancedFeatures }) {
  console.debug('hoaId=' + hoaId)

  const allowed = function(permission) {
    return auth.hasTenantPermission(permission)
  }

  const isaTenant = function() {
    return auth.isTenant()
  }

  const checkFeature = function(permission) {
    console.debug('checkFeature for.....' + permission)

    let permissionSet = false

    console.debug('enhancedFeatures.....' + enhancedFeatures.length)

    if (enhancedFeatures !== undefined && enhancedFeatures && enhancedFeatures.length > 0) {
      const filtered = enhancedFeatures.filter(f => f === permission)[0]
      if (filtered !== undefined && filtered) {
        permissionSet = true
      }
    }

    console.debug('homeowner permission=' + permission + ', ' + permissionSet)

    return permissionSet
  }

  const items = [
    {
      to: '/',
      iconC: PropertyIcon,
      label: 'Home'
    },
    ...[
      allowed('TENANT_MAKE_PAYMENTS') === true && checkFeature('accounting') === true
        ? apps.accountActivity
        : {}
    ],
    {
      to: '/communityCenter',
      iconC: SurveyIcon,
      label: 'Community Info'
    },
    ...[checkFeature('violations') === true ? apps.violations : {}],
    ...[
      allowed('TENANT_SUBMIT_ARCH_REQUESTS') === true &&
      checkFeature('architectural-requests') === true
        ? apps.architecturalRequests
        : {}
    ],
    ...[
      isaTenant() === true && checkFeature('tenants') === false
        ? {}
        : checkFeature('tenants') === true && isaTenant() === false
        ? apps.tenants
        : {}
    ],
    ...[checkFeature('amenities') === true ? apps.amenities : {}],
    ...[checkFeature('ballots') === true ? apps.evoting : {}],
    ...[
      (allowed('TENANT_SUBMIT_WORK_ORDER_REQUESTS') === true &&
      checkFeature('homeowner-work-order-requests') === true) || checkFeature('work-order-requests')
        ? apps.workOrderRequests
        : {}
    ],
    ...[checkFeature('homeowner-directory') === true ? apps.directoryContacts : {}],
    {
      to: '/userSettings/profile#tab',
      iconC: AccountIcon,
      label: 'User Settings'
    },
    {
      to: '/property/contacts#tab',
      iconC: PropertyIcon,
      label: 'Property Settings'
    },
    {
      to: '/helpCenter',
      iconC: HelpCenterIcon,
      label: 'Help Center'
    },
    {
      to: '/customerSupport',
      iconC: CustomerSupportIcon,
      label: 'Customer Support'
    }
  ]

  return items
}
